import React from "react";

const ZoneContext = React.createContext(null);

export default ZoneContext